import { useEffect, useState } from "react";
import { InputBox } from "../Components/InputBox";
import { TextButton } from "../Components/SingleButtton";
import { useNavigate } from "react-router-dom";
import { GoogleLoginButton, GoogleLogoutButton } from "../Components/Login/GoogleLogInButton";
import { FacebookLoginButton } from "../Components/Login/FacebookLoginButton";
import { MessageModal } from "../Components/Modals/MessageModal";
import { accountIdMap, tempLegalAccounts } from "../Utils/TempLegalAccounts";

const Login = () => {
  const [mode, setMode] = useState('account')
  const [account, setAccount] = useState('')
  const [password, setPassword] = useState('')
  const [activation, setActivation] = useState('')
  const [modalVis, setModalVis] = useState(false)
  const [modalMsg, setModalMsg] = useState('')
  const navigate = useNavigate()

  /*
  useEffect(() => {
    const handleEnterKey = (evt) => {
      // console.log('User pressed:', evt.key)
      evt.preventDefault()
      if (evt.key === 'Enter') {
        handleLoginSubmit()
      }
    }

    document.addEventListener('keydown', handleEnterKey)

    return () => {
      document.removeEventListener('keydown', handleEnterKey)
    }
  }, [])
  */

  const handleAccountInput = (evt) => { setAccount(evt.target.value) }
  const handlePasswordInput = (evt) => { setPassword(evt.target.value) }
  const handleActivationInput = (evt) => { setActivation(evt.target.value) }
  const clearInput = () => {
    setAccount('')
    setPassword('')
    setActivation('')
  }
  const handleLoginSubmit = () => {
    // console.log('act:', account)
    // console.log('pwd:', password)
    if (tempLegalAccounts[account] === undefined || tempLegalAccounts[account] !== password) {
      setModalMsg('帳號密碼錯誤\nAccount / Password Incorrect!')
      setModalVis(true)
    } else {
      localStorage.setItem('stats-insight-login', 'true')
      localStorage.setItem('stats-insight-login-info', JSON.stringify({id: accountIdMap[account], expiredTime: new Date(Date.now()+12*3600*1000)}))
      navigate('/filter')
    }
    // navigate('/main')
    clearInput()
  }
  
  const handleModeSwitch = (dest) => {
    setMode(dest)
    clearInput()
  }

  const SwitchMode = (modeType) => {
    if (modeType === 'account') {
      return (
        <>
          <InputBox usage='login' type="text" id="id" placeholder="帳號" value={account} onChange={handleAccountInput} />
          <InputBox usage='login' type="password" id="password" placeholder="密碼" value={password} onChange={handlePasswordInput} />
          <div className="login_form_left">
            <a>點我註冊</a>
          </div>
          <div className="login_form_right">
            <a>忘記密碼？</a>
          </div>
          <div className="clear" />
          <TextButton usage="login" onClick={handleLoginSubmit} text={'登入'} />
          {/*<FacebookLoginButton />*/}
          {/*<GoogleLoginButton />*/}
          {/*
          <div className="login_or">or</div>
          <div className="login_activation">
            <span onClick={()=>{handleModeSwitch('activation')}}>啟動碼登入</span>
          </div>
          */}
        </>
      )
    } else {
      return (
        <>
          <InputBox usage='login' type="text" id="id" placeholder="帳號" value={account} onChange={handleAccountInput} />
          <InputBox usage='login' type="password" id="password" placeholder="啟動碼" value={activation} onChange={handleActivationInput} />
              <div className="login_form_left">
                <label htmlFor="remember"><input type="checkbox" id="remember"/>記住我</label>
              </div>
              <div className="login_form_right">
                <a>忘記啟動碼？</a>
              </div>
              <div className="clear" />
              <TextButton usage="login" onClick={handleLoginSubmit} text={'登入'} />
              <div className="login_or">or</div>
              <div className="login_activation">
                <span onClick={()=>{handleModeSwitch('account')}}>帳號密碼登入</span>
              </div>  
        </>
      )
    }
  }

  return (
    <>
      <MessageModal type={'error'} visible={modalVis} message={modalMsg} setVisible={setModalVis} />
      <div className="wrapper bg_login">
        <div className="wrap_setin">
          <div className="login_frame">
            <div className="login_left">
              <div className="login_logo" />
              <div className="login_intro">
                灼見運動數據致力於開發棒球場上的影像數據整合方案。由10隻攝影機角度提供電子好球帶、轉速、擊球等追蹤演算，開發視覺化界面。為球隊提供對戰情蒐，和球迷數據體驗。希望一起把科技帶進台灣的棒球場。
                <br /><br />
                我們是由專業的團隊組成，包含中華隊十二強和奧運的情蒐教練和中華職棒電子好球帶的開發工程師。取名 Insight 背後有深刻見解的意思，可以灼見棒球數據背後的意義。 「In sight」也有看得見、就在眼前的意思，象徵著台灣數據棒球的時代正要展開。
                <br /><br />
                <span>StatsInsight provides advance data solution in a single platform that enables teams, media, and fans to unlock the secrets behind the games we all loved. We have a  complete set of capabilities,  using sophisticated vision processing technology along with our scoring software to provide meaningful data and video clips for visual statistics and analytics use.</span>
              </div>
            </div>
            <div className="login_right">
              <div className="login_form">
                {SwitchMode(mode)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Login